import { html } from "lit-html"

// Kept mounted so screen readers announce the message when it appears
const StatusNotice = ({ visible }) => html`
  <div role="status" aria-live="polite">
    ${visible
      ? html`<p class="filter-status-notice visually-hidden">
          Showing all statuses because a Role Status filter is applied.
        </p>`
      : ``}
  </div>
`

export default StatusNotice
